import { IBasket } from "@shared/modules/basket/interfaces/IBasket";

export const getCustomQuestionsParams = (
  publicBasket: IBasket,
  stepId?: string,
  forceGuestCheckout?: boolean,
  hasGuestCheckout?: boolean
) => {
  if (stepId === "login") {
    return {
      force_guest_checkout: forceGuestCheckout,
      has_guest_checkout: hasGuestCheckout,
    };
  }

  if (stepId !== "custom-questions") return {};

  const requiredCustomQuestionsCount = publicBasket.itemGroups
    .find((ig) => ig.info_custom_question_data?.length)
    ?.info_custom_question_data?.filter((q) => q.required).length;

  // count the fields that start wth "collect_info" and are true
  const requiredEnhancedInfoCollection =
    publicBasket.itemGroups[0].collect_info_fields || {};
  const fieldKeys = Object.keys(requiredEnhancedInfoCollection);

  const enhancedInfoCollectionFields = fieldKeys.filter(
    (key) =>
      key.startsWith("collect_info") &&
      requiredEnhancedInfoCollection[
        key as keyof typeof requiredEnhancedInfoCollection
      ]
  );

  const enhancedInfoCollectionFieldsCount =
    enhancedInfoCollectionFields?.length;

  return {
    order_form_complexity: {
      has_enhanced_info_collection: publicBasket.hasAdditionalInfoCollection,
      multi_guest_enabled:
        publicBasket.itemGroups.filter((ig) => ig.info_required).length > 0,
      custom_questions_count: publicBasket.itemGroups.find(
        (ig) => ig.info_custom_question_data?.length
      )?.info_custom_question_data?.length,
      required_custom_questions_count: requiredCustomQuestionsCount,
      required_enhanced_info_collection_fields_count:
        enhancedInfoCollectionFieldsCount,
    },
  };
};

// In the future we want the uuid to come from the analytics endpoint but until that backend work
// is done we should be able to handle it coming from the api endpoint
export const getFBOpts = (
  analyticsUUID?: string,
  optsUUID?: string | unknown
) => {
  return (optsUUID as string | undefined) ?? analyticsUUID ?? "";
};
